<template>
  <TimeLine class="mt-4 mx-3">
    <TimeLineItem
      v-for="(row, index) in statusHistory"
      :key="index"
      class="custom-time-line rounded"
    >
      <template #icon>
        <em class="color-white fa-exchange far radius" />
      </template>
      <template #date>
        <div class="date-container">
          <div class="color-black font-16 font-weight-bold fulldate">
            {{ row.date }}
            <small>{{ row.hour }}</small>
          </div>
        </div>
      </template>
      <div class="row">
        <div class="col-12 col-md-2 flex-column d-flex">
          <label class="mb-0 px-2 pt-1 font-weight-bold">
            Cambio de Estatus
          </label>
        </div>
        <div
          class="d-none d-md-block col-md-1 border-left--color-gray vertical-line"
        />
        <div class="col-12 col-md-3 mt-2 flex-column d-flex">
          <label class="mb-0 color-gray-6 text-small">Estatus:</label>
          <span class="d-flex align-items-baseline">
            <div
              class="status-indicator"
              :style="{ backgroundColor: row.status.color }"
            >
              &nbsp;
            </div>
            <span class="info-text">{{ row.status.text }}</span>
          </span>
        </div>
        <div class="col-12 col-md-3 mt-2 flex-column d-flex">
          <label class="mb-0 color-gray-6 text-small">Usuario:</label>
          <span class="info-text">{{ row.statusUpdatedBy }}</span>
        </div>
        <div class="col-12 col-md-3 flex-column d-flex mt-2">
          <label class="mb-0 color-gray-6 text-small">Descripción:</label>
          <span class="info-text">{{ row.statusChangeDescription }}</span>
        </div>
      </div>
    </TimeLineItem>
  </TimeLine>
</template>

<script>
import moment from 'moment';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import { getOrderHistory } from '@/modules/books-requests/api';
import { getStudentBookStatusColor } from '@/utils/constants/book/studentBookStatus';

export default {
  name: 'History',
  props: {
    book: {
      type: Object,
      required: true,
      default() {
        return {
          bookId: '',
          studentSieId: '',
          academicYearId: '',
        };
      },
    },
  },
  components: {
    TimeLine,
    TimeLineItem,
  },
  data: () => ({
    statusHistory: [],
  }),
  methods: {},
  async mounted() {
    const filters = {
      bookId: this.book.bookId,
      studentSieId: this.book.studentSieId,
      academicYearId: this.book.academicYearId,
      isUndoHistory: true,
    };
    const { data } = await getOrderHistory(filters);
    this.statusHistory = data.map((item) => ({
      ...item,
      status: {
        text: item.status,
        color: getStudentBookStatusColor(item.statusId, true),
      },
      date: moment(item.historyCreateDate).format('DD/MM/YYYY'),
      hour: moment(item.historyCreateDate).format('h:mm A'),
    }));
  },
};
</script>

<style lang="scss" scoped>
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.vertical-line {
  border-left: 1px solid;
  max-width: 0;
}
</style>
